import './firebase';

import Vue from 'vue'
import firebase from 'firebase';
import App from './App.vue'
import store from './store'
import router from './router'
import './plugins/element.js'

Vue.config.productionTip = false



let app = null;
firebase.auth().onAuthStateChanged((user) => {
  console.log('auth state change', user && user.uid);
  if(!app) {
    app = new Vue({
      store,
      router,
      render: h => h(App)
    }).$mount('#app')
  }
  
  if(user && user.uid) {
    const users = firebase.firestore().collection('users');
    users.doc(user.uid).get().then(dbuser => {
      if(!dbuser.exists) {
        console.log('auth state changed, user does not exist');
        const userData = {id: user.uid, name: user.displayName || "", email: user.email||""};
        users.doc(user.uid).set(userData)
        .then(() => store.dispatch('initCurrentUser', userData.id))
        .catch(err => console.log('err saving user', err.message));
      } else {
        store.dispatch('initCurrentUser', dbuser.id)
      }
    }).catch(err => console.log('err getting user', err.message));
  } else {
    store.dispatch('deinitCurrentUser');
  }
});


